module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "overlay-alert"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "alert-box"
  }, [_c('h4', [_vm._v("Block & Report " + _vm._s(_vm.firstname + ' ' + _vm.surname) + "?")]), _vm._v(" "), _c('a', {
    staticClass: "btn-remove",
    on: {
      "click": _vm.closeOverlay
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('p', [_c('label', [_vm._v("Tell us why you want to report " + _vm._s(_vm.firstname) + ":")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.reportReason),
      expression: "reportReason",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "modal",
    attrs: {
      "rows": "6",
      "placeholder": 'I want to report ' + _vm.firstname + ' because...'
    },
    domProps: {
      "value": (_vm.reportReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reportReason = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('a', {
    staticClass: "link-simple",
    on: {
      "click": _vm.closeOverlay
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "btn active",
    on: {
      "click": _vm.reportUser
    }
  }, [_vm._v("Block & Report")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ede54ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/BlockReport.vue
// module id = 716
// module chunks = 1